import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapGetters(['isDisableButton'])
  },
  methods: {
    ...mapMutations(['SET_DISABLE_BUTTON']),
    enableButton () {
      this.SET_DISABLE_BUTTON(false)
    }
  }
}
